"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const useFetch_1 = __importDefault(require("../../../hooks/useFetch"));
const common_styled_components_1 = require("../../common-styled-components");
const apiUtils_1 = require("../../../util/apiUtils");
const theme_1 = require("../../../theme");
const PoolTable_1 = require("../common/tables/PoolTable");
const useMetadata_1 = require("../../../hooks/useMetadata");
const FleetTable_1 = require("../common/tables/FleetTable");
const ShipTable_1 = require("../common/tables/ShipTable");
const NumberKPI_1 = __importDefault(require("../common/NumberKPI"));
const YearContext_1 = require("../../../contexts/YearContext");
const react_1 = require("react");
exports.default = () => {
    const { selectedYear } = (0, YearContext_1.useYear)();
    const [user] = (0, useFetch_1.default)("user/data.json");
    const [pools, _setPoolsUrl, _setPoolsPostBody, refreshPools] = (0, useFetch_1.default)("pool/pools.json", JSON.stringify({ pool_id: null, year: selectedYear }));
    const [fleets, _setFleetsUrl, _setFleetsPostBody, refreshFleets] = (0, useFetch_1.default)("fleet/fleets.json", JSON.stringify({ year: selectedYear }));
    const [ships, _setShipsUrl, _setShipsPostBody, refreshShips] = (0, useFetch_1.default)("ship/ships.json", JSON.stringify({ year: selectedYear }));
    (0, react_1.useEffect)(() => {
        // Refresh data when selectedYear changes
        _setPoolsPostBody(JSON.stringify({
            pool_id: null,
            year: selectedYear,
        }));
        _setFleetsPostBody(JSON.stringify({
            year: selectedYear,
        }));
        _setShipsPostBody(JSON.stringify({
            year: selectedYear,
        }));
    }, [selectedYear]);
    const [metadata] = (0, useMetadata_1.useMetadata)();
    // log([
    //   {
    //     label: "User",
    //     content: user.status === LoaderStatus.Success ? user.data : "loading",
    //   },
    //   {
    //     label: "Pools",
    //     content: pools.status === LoaderStatus.Success ? pools.data : "loading",
    //   },
    //   {
    //     label: "Fleets",
    //     content: fleets.status === LoaderStatus.Success ? fleets.data : "loading",
    //   },
    //   {
    //     label: "Ships",
    //     content: ships.status === LoaderStatus.Success ? ships.data : "loading",
    //   },
    // ]);
    const errorState = [user, fleets, pools, ships].find((s) => s.status === apiUtils_1.LoaderStatus.Error);
    if (errorState) {
        return ((0, jsx_runtime_1.jsxs)(common_styled_components_1.PageContent, { align: "left", children: ["Error: ", String(errorState.error)] }));
    }
    if (user.status !== apiUtils_1.LoaderStatus.Success ||
        !user.data ||
        fleets.status !== apiUtils_1.LoaderStatus.Success ||
        !fleets.data ||
        pools.status !== apiUtils_1.LoaderStatus.Success ||
        !pools.data ||
        ships.status !== apiUtils_1.LoaderStatus.Success ||
        !ships.data ||
        !metadata) {
        return (0, jsx_runtime_1.jsx)(common_styled_components_1.PageContent, { align: "left", children: "Loading\u2026" });
    }
    const nonCompliantShips = ships.data.filter((s) => s.intensity.adjusted_emission_balance_ton < 0).length;
    const nonCompliantPools = pools.data.filter((p) => p.intensity.adjusted_emission_balance_ton < 0).length;
    return ((0, jsx_runtime_1.jsx)("div", { style: { width: "100%" }, children: (0, jsx_runtime_1.jsxs)(common_styled_components_1.PageContent, { align: "left", children: [(0, jsx_runtime_1.jsxs)(common_styled_components_1.ContentGrid, { children: [(0, jsx_runtime_1.jsxs)(common_styled_components_1.GridCard, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.SectionTitle, { children: user.data.company.name }), (0, jsx_runtime_1.jsxs)(common_styled_components_1.PTight, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.Bold, { children: "Ships: " }), ships.data.length] }), (0, jsx_runtime_1.jsxs)(common_styled_components_1.PTight, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.Bold, { children: "Pools: " }), pools.data.length] }), (0, jsx_runtime_1.jsxs)(common_styled_components_1.PTight, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.Bold, { children: "Fleets: " }), fleets.data.length] })] }), (0, jsx_runtime_1.jsx)(common_styled_components_1.GridCard, { children: (0, jsx_runtime_1.jsx)(NumberKPI_1.default, { title: "non-compliant ships", value: nonCompliantShips, color: nonCompliantShips > 0
                                    ? theme_1.theme.colors.blackText
                                    : theme_1.theme.colors.green }) }), (0, jsx_runtime_1.jsx)(common_styled_components_1.GridCard, { children: (0, jsx_runtime_1.jsx)(NumberKPI_1.default, { title: "non-compliant pools", value: nonCompliantPools, color: nonCompliantPools > 0
                                    ? theme_1.theme.colors.blackText
                                    : theme_1.theme.colors.green }) })] }), (0, jsx_runtime_1.jsx)(common_styled_components_1.ContentGrid, { children: (0, jsx_runtime_1.jsx)(common_styled_components_1.GridCard, { "$cols": 3, children: (0, jsx_runtime_1.jsx)(PoolTable_1.PoolTable, { pools: pools.data, isInAdminTools: false }) }) }), (0, jsx_runtime_1.jsx)(common_styled_components_1.ContentGrid, { children: (0, jsx_runtime_1.jsx)(common_styled_components_1.GridCard, { "$cols": 3, children: (0, jsx_runtime_1.jsx)(FleetTable_1.FleetTable, { fleets: fleets.data, isInAdminTools: false }) }) }), (0, jsx_runtime_1.jsx)(common_styled_components_1.ContentGrid, { children: (0, jsx_runtime_1.jsx)(common_styled_components_1.GridCard, { "$cols": 3, children: (0, jsx_runtime_1.jsx)(ShipTable_1.ShipTable, { ships: ships.data, isInAdminTools: false, metadata: metadata, year: selectedYear, userCompanyId: user.data.company.id, showPool: true }) }) })] }) }));
};
